import { useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import TopNav from "@/components/TopNav";

export default function VideoInstructions() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const startAt = Math.max(0, Number(params.get("t")) || 0);
  const from = params.get("from"); // e.g. "step-4"
  const src = useMemo(
    () => `/videos/gdk-base.mp4${startAt > 0 ? `#t=${startAt}` : ""}`,
    [startAt]
  );

  const goBack = () => {
    // Always use an explicit anchor return — browser history + scroll
    // restoration is unreliable on SPA pages whose height changes as
    // media/images load.
    navigate(from ? `/v/A?goto=${from}` : "/v/A");
  };

  return (
    <div
      className="min-h-screen flex flex-col bg-[var(--bg-base)]"
      data-testid="video-page"
    >
      <TopNav />

      <main className="flex-1 w-full mx-auto max-w-3xl px-4 sm:px-6 py-8 sm:py-12">
        <div className="mb-8 text-center">
          <span className="font-hand text-3xl sm:text-4xl text-[var(--accent)] inline-block -rotate-2">
            Video Guide
          </span>
          <h1
            className="mt-2 font-heading text-3xl sm:text-4xl font-semibold tracking-tight"
            data-testid="video-title"
          >
            Watch the whole build.
          </h1>
        </div>

        <div
          className="card-brut bg-black overflow-hidden aspect-video relative"
          data-testid="video-player-wrap"
        >
          <video
            key={src}
            controls
            autoPlay
            playsInline
            preload="auto"
            src={src}
            className="w-full h-full object-contain bg-black"
            data-testid="video-player"
            data-start-at={startAt}
          />
        </div>
      </main>

      {from && (
        <div
          className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 flex items-center gap-6"
          data-testid="video-bottom-nav"
        >
          <button
            type="button"
            onClick={goBack}
            aria-label={`Back to ${from}`}
            data-testid="video-back-btn"
            className="arcade-btn px-4 py-3 text-[11px] sm:text-xs"
          >
            <ChevronLeft strokeWidth={3} className="h-5 w-5" />
            Back to step {from.replace(/^step-/, "")}
          </button>
        </div>
      )}
    </div>
  );
}
